import { render, staticRenderFns } from "./Testing.vue?vue&type=template&id=03358bdb&"
import script from "./Testing.vue?vue&type=script&lang=js&"
export * from "./Testing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03358bdb')) {
      api.createRecord('03358bdb', component.options)
    } else {
      api.reload('03358bdb', component.options)
    }
    module.hot.accept("./Testing.vue?vue&type=template&id=03358bdb&", function () {
      api.rerender('03358bdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/viewKnowledge/testing/Testing.vue"
export default component.exports